import { KEY } from '../../types';

export const GET_SPEED_PASS = `${KEY}.GET_SPEED_PASS`;
export const GET_SPEED_PASS_SUCCESS = `${KEY}.GET_SPEED_PASS_SUCCESS`;
export const GET_SPEED_PASS_FAIL = `${KEY}.GET_SPEED_PASS_FAIL`;
export const GET_SPEED_PASS_CLEAR = `${KEY}.GET_SPEED_PASS_CLEAR`;
